import { endpoints } from '../endpoints';
import { parseResponse } from '../parseResponse';
import { getHeader } from './generalApi';

export async function getDashboards() {
  return fetch(`${endpoints.dashboards}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}
